import React, { useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { SessionContext } from "../context/sessionContext";

const LoadingSpinner = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontSize: "18px",
      flexDirection: "column",
    }}
  >
    <div>Loading...</div>
    <div
      style={{
        fontSize: "12px",
        marginTop: "10px",
        color: "#666",
      }}
    >
      Checking authentication...
    </div>
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, checkAuth } = useContext(SessionContext);
  const location = useLocation();

  useEffect(() => {}, [location.pathname, isAuthenticated, isLoading]);

  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/log-in" state={{ from: location.pathname }} replace />
    );
  }

  return children;
};

export const PublicRoute = ({ children, redirectTo = "/projects" }) => {
  const { isAuthenticated, isLoading } = useContext(SessionContext);
  const location = useLocation();

  useEffect(() => {}, [isAuthenticated, isLoading]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const isPendingSignup =
    sessionStorage.getItem("pendingSignupFlow") === "true";

  const authPages = ["/log-in", "/sign-up", "/Sign-up"];
  const isAuthPage = authPages.includes(location.pathname);

  if (isAuthenticated && isAuthPage) {
    if (isPendingSignup) {
      return children;
    }

    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export const MixedRoute = ({ children }) => {
  const { isLoading } = useContext(SessionContext);
  const location = useLocation();

  useEffect(() => {}, [location.pathname]);

  if (isLoading) {
    return <LoadingSpinner />;
  }
  return children;
};

export const SignupFlowRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useContext(SessionContext);
  const location = useLocation();

  useEffect(() => {}, [location.pathname, isAuthenticated, isLoading]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const isPendingSignup =
    sessionStorage.getItem("pendingSignupFlow") === "true";
  const signupFlowPages = [
    "/create-org",
    "/pricing",
    "/define-audience",
    "/create-survey",
  ];
  const isSignupPage = signupFlowPages.includes(location.pathname);

  if (isAuthenticated && isSignupPage && !isPendingSignup) {
    return <Navigate to="/projects" replace />;
  }
  return children;
};
